import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rawPolicy from "@living/privacy-policy.md?raw";
import { stripInternalAnnotations } from "@/lib/strip-flag-callouts";
import { LegalPageLayout } from "@/components/legal/LegalPageLayout";
import { Seo } from "@/components/public/Seo";

export default function PrivacyPolicy() {
  const cleaned = stripInternalAnnotations(rawPolicy);
  return (
    <LegalPageLayout>
      <Seo path="/privacy-policy" />
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{cleaned}</ReactMarkdown>
    </LegalPageLayout>
  );
}
